import { useTranslation } from 'react-i18next';

export default function ButtonTab2({ data = [], active, setActive, classNameButton = "" }) {
	const { t } = useTranslation()

	return (
		<div className="flex w-full rounded-full bg-[#F7E4C6] p-2 border-2 border-[#FFF7EA] shadow-lg gap-2 mb-5 mt-3">
			{data?.map((tab) => {
				const isActive = active === tab.id;
				return (
					<button
						key={tab.id}
						onClick={() => setActive(tab.id)}
						className={`
          flex-1
          h-auto
          rounded-full
          font-bold
          text-[28px]
          transition-all
          duration-300
          cursor-pointer
					btn-click-active
					outline-none
					py-2.5
					${classNameButton}
          ${isActive
								? "bg-gradient-to-b from-[#FFC768] via-[#FF8A49] to-[#FF5A2C]"
								: "bg-[#F6F4EF]"
							}
        `}
						style={
							isActive
								? {
									textShadow: "0 2px 4px rgba(224,79,22,0.8)",
									color: "rgba(251,245,218,1)",
								}
								: {
									color: "#9B5A09",
								}
						}
					>
						{t(tab.label)}
					</button>
				);
			})}
		</div>
	)
}
